import React from 'react'
import './Footer.css';
import {Link} from "react-router-dom"

function Footer() {
  return (
    <div className='footer'>
       <div className='footer-con'>
        <div>
          <p>Fatima Hospital</p>
           <div className='social-links'>
              <Link  to= {""}> <div className='social-box'><img src="https://res.cloudinary.com/dxnukbo0u/image/upload/v1706376471/icons8-facebook-50_mygc3g.png" alt=""/></div></Link>
              <Link  to= {""}> <div className='social-box'><img src="https://res.cloudinary.com/dxnukbo0u/image/upload/v1706376471/icons8-x-50_mmnjjz.png" alt=""/></div></Link>
              <Link  to= {""}> <div className='social-box'><img src="https://res.cloudinary.com/dxnukbo0u/image/upload/v1706376471/icons8-instagram-50_1_spmzfu.png" alt=""/></div></Link>
              <Link  to= {""}> <div className='social-box'><img src="https://res.cloudinary.com/dxnukbo0u/image/upload/v1706472517/icons8-tiktok-50_dlug3j.png" alt=""/></div></Link>
            </div>
        </div>

        <div className='quick'>
           <p>Quick Links</p>
           <span>About Us</span>
           <span>Why Choose Us</span>
           <span> Our Services</span>
           <span>Testimonials</span>
        </div>

        <div className='quick'>
           <p>Information</p>
           <span>Cardiology</span>
           <span>Orthopedics</span>
           <span>Pediatrics</span>
           <span>Gynecology</span>
        </div>

        <div className='quick'>
           <p>Opening Hours</p>
           <span>Monday to Sunday</span>
           <span>Open 24hours</span>
        </div>
       </div>

      
      
    </div>
  )
}

export default Footer